"use client"

import { Button } from "@mui/material"
import { motion } from "framer-motion"

const PrimaryButton = ({ children, variant = "contained", color = "primary", sx = {}, ...props }) => {
  return (
    <Button
      component={motion.button}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      variant={variant}
      color={color}
      sx={{
        borderRadius: 50,
        padding: "10px 24px",
        fontWeight: 600,
        boxShadow: variant === "contained" ? "0 4px 14px 0 rgba(99, 102, 241, 0.39)" : "none",
        "&:hover": {
          boxShadow: variant === "contained" ? "0 6px 20px rgba(99, 102, 241, 0.5)" : "none",
          transform: "translateY(-2px)",
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default PrimaryButton

